<template>
    <div class="logo">
        <div class="container">
            <router-link  to="/" tag="div" class="img">
                <img src="../assets/logo.png" alt />
            </router-link>
            <div class="search">
                <el-input placeholder="请输入名称搜索" v-model="q">
                    <el-button
                        class="input-btn"
                        slot="append"
                        icon="el-icon-search"
                        @click="onSearch()"
                    ></el-button>
                </el-input>
                <el-button class="search-btn" type="success">结构式搜索</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'v-logo',
    data() {
        return {
            q: '',
        };
    },
    methods: {
        onSearch() {
            this.$router.push({ path: '/search', query: { q: this.q } });
        },
    },
};
</script>

<style lang="less" scoped>
.logo {
    padding: 20px 0;
    .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .img {
            cursor: pointer;
            width: 200px;
            height: 52.5px;
            img {
                width: 100%;
            }
        }
        .search {
            display: flex;
            justify-content: flex-end;
            height: 40px;
            .el-input {
                width: 500px;
                margin-right: 20px;
            }
            .input-btn {
                background-color: #3c9539;
                border-radius: 0 4px 4px 0;
                color: #fff;
            }
            .search-btn {
                background-color: #3c9539;
            }
        }
    }
}
</style>